import { REQUEST } from 'crom-api-constants'

export const FORM_ID = 'changePassword'
export const FIELD = {
    CURRENT_PASSWORD: 'currentPassword',
    NEW_PASSWORD: 'newPassword',
    NEW_PASSWORD_CHECK: 'newPasswordCheck',
}

export const PASSWORD_STRENGTH_LIMIT = 1 // 0 - 4 from zxcvbn package

export const SUBMIT_CHANGE_PASSWORD_FORM = 'SUBMIT_CHANGE_PASSWORD_FORM'
export const CHANGE_PASSWORD_REQUEST = `CHANGE_PASSWORD_${REQUEST}`

export const LOCALE_PREFIX =
    'components.Dialog.components.UserProfile.components.Content.components.ChangePassword.components.ChangePasswordForm'
